export default __webpack_public_path__ + "static/media/K0006.78d1473b.png";